import { round } from 'mathjs';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import { ActionAllowed } from '../rbac/rbacutil';
import { rbacactions } from '../rbac/rbacrules';
import {
    getContractPrices,
    saveContractPrice,
    deleteContractPrice,
    uploadContractPriceUpdateExcel,
    doContractPriceUpdates,
} from '../modules/productdata';
import { getContractPricePricingRequests } from '../modules/contractpricerequestdata';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    FormControl,
    InputLabel,
    NativeSelect,
    IconButton,
    Chip,
    Stack,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import Contract from '../domain/contract';
import ContractPrice from '../domain/contractprice';
import ContractPricesProduct from './contractpricesproduct';
import { filter, sortBy, some, orderBy } from 'lodash';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import FilterProductSelectDialog from '../location/filterproductselectdialog';
import DeleteConfirmDialog from '../common/deleteconfirmdialog';
import ConfirmationDialog from '../common/confirmationdialog';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { getProductListXlsxForContract } from '../modules/productdata';
import { CircularProgressWithLabel } from '../common/circularprogresslabel';
import { removeContractPricePricingRequest } from '../modules/contractpricerequestdata';
import { updateContractData } from '../modules/contractdata';
import ParameterSelector from '../common/parameterselector';
import ContractPricesStandardPricing from './contractpricesstandardpricing';
import CargoPricingPanel from './cargopricingpanel';
import { getPricingRules } from '../modules/standardbasedpricingdata';
import { getLocationsByContractNumberAndProductNumber } from '../modules/locationdata';
import LocationListDialog from '../common/locationListDialog';
import { listAllTenants } from '../modules/tenantdata';
import { resolveCurrencyForTenantClusterId } from '../common/currencyutils';
const dayjs = require('dayjs');

const styles = {
    accordion: { mt: '0.5em' },
    addbutton: { mb: '1em', mt: '0.5em' },
    uploadBtn: { mt: '7px' },
    formControl: { minWidth: 250, mt: 1, mb: 3 },
    ruleItem: (theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 1,
        my: 0.5,
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #ccc',
    }),
};

function CpUploadButton(props) {
    const contractId = props.contractId;
    const disabled = props.disabled;
    const { t } = useTranslation();

    const fileUpd = (e) => {
        props.setUploadFile(contractId, e.target.files[0]);
    };

    return (
        <React.Fragment>
            <label htmlFor={'upload-excel-' + contractId}>
                {!disabled && (
                    <input
                        style={{ display: 'none' }}
                        id={'upload-excel-' + contractId}
                        name={'upload-excel-' + contractId}
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        onChange={fileUpd}
                        type="file"
                    />
                )}

                <Button
                    sx={styles.uploadBtn}
                    color="primary"
                    disabled={disabled}
                    component="span"
                    aria-label="add"
                    variant="contained"
                    startIcon={disabled ? <CircularProgress color={'secondary'} size={'1rem'} /> : <CloudUploadIcon />}>
                    {t('buttons.update')}
                </Button>
            </label>
        </React.Fragment>
    );
}

export default function ContractPrices(props) {
    const contractPrices = useSelector((state) => state.productdata.contractPricesByContractId);
    const parameters = useSelector((state) => state.parameterdata.parameters);
    const user = useSelector((state) => state.authentication.userProfile);
    const allProducts = useSelector((state) => state.productdata.filterProducts);
    const bundles = useSelector((state) => state.productdata.productBundles);
    const pricingRequestByContractNumberId = useSelector(
        (state) => state.contractpricetequestdata.pricingRequestsByContractNumberId
    );
    const pricingReqsLoading = useSelector((state) => state.contractpricetequestdata.loadingPricingRequests);
    const updateStatus = useSelector((state) => state.productdata.contractpricingUpdateStatus);
    const contracts = useSelector((state) => state.contractdata.contractsById);
    const pricingRules = useSelector((state) => state.standardbasedpricingdata.pricingRules);
    const loadingPricingRules = useSelector((state) => state.standardbasedpricingdata.fetchingData);
    const tenants = useSelector((state) => state.tenantdata.allTenants);
    const [selectedRow, setSelectedRow] = useState({});
    const [editOpenRow, setEditOpenRow] = useState({});
    const [priceInEdit, setPriceInEdit] = useState(null);
    const [saving, setSaving] = useState(false);
    const [sortedIdsByContractId, setSortedIdsByContractId] = useState({});

    const [reff] = useState(React.createRef());
    const [blobUrl, setBlobUrl] = useState('');
    const [downloadFilename, setDownloadFilename] = useState('');
    const [loadingXlsx, setLoadingXlsx] = useState(false);

    // for adding new contract price
    const [showNewProdSelector, setShowNewProdSelector] = useState(false);
    const [contractIdInScope, setContractIdInScope] = useState(null);
    const [addNewProdTitle, setAddNewProdTitle] = useState('');

    // for removing contract price
    const [deleteConfirmTitle, setDeleteConfirmTitle] = useState('');
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    // for changing the pricing scheme between fixed <-> percentage based
    const [confirmChangePricingSchemeText, setConfirmChangePricingSchemeText] = useState('');
    const [confirmChangeSchemeOpen, setConfirmChangeSchemeOpen] = useState(false);
    const [confirmSchemeChangeParams, setConfirmSchemeChangeParams] = useState({});

    // contract price update via excel
    const [uploading, setUploading] = useState(false);
    const [uploadResults, setUploadResults] = useState(null);
    const [cpUpdateUid, setCpUpdateUid] = useState(null);
    const [updateContractId, setUpdateContractId] = useState(null);
    const [showPricingRuleSelect, setShowPricingRuleSelect] = useState({});
    const [savingRule, setSavingRule] = useState({});
    const [deletingRule, setDeletingRule] = useState(null);

    // location list dialog
    const [locationListDialogOpen, setLocationListDialogOpen] = useState(false);
    const [locationListDialogLocations, setLocationListDialogLocations] = useState([]);
    const [locationListDialogLoading, setLocationListDialogLoading] = useState(true);

    // contract expanded list
    const [contractsExpanded, setContractsExpanded] = useState({});

    // tenant filtering for the contract number list, same behaviour as the admin contracts page
    const [tenantFilter, setTenantFilter] = useState(null); // null = show all tenants' contract numbers

    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (!tenants || tenants.length === 0) {
            dispatch(listAllTenants());
        }
    }, [dispatch, tenants]);

    useEffect(() => {
        if (!pricingRules && !loadingPricingRules) {
            dispatch(getPricingRules());
        }
    }, [dispatch, pricingRules, loadingPricingRules]);

    useEffect(() => {
        if (!pricingRequestByContractNumberId && !pricingReqsLoading) {
            dispatch(getContractPricePricingRequests());
        }
    }, [dispatch, pricingRequestByContractNumberId, pricingReqsLoading]);

    useEffect(() => {
        for (const c of Object.keys(contractsExpanded)) {
            if (contractsExpanded[c] && !contractPrices[c]) {
                getContractPrices(c)(dispatch);
            }
        }
    }, [contractsExpanded, contractPrices, dispatch]);

    useEffect(() => {
        const newEntries = {};
        for (const [contractId, prices] of Object.entries(contractPrices)) {
            if (!prices) continue;
            const cached = sortedIdsByContractId[contractId];
            const sorted = sortPrices(prices, pricingRequestByContractNumberId && pricingRequestByContractNumberId[contractId]);
            if (!cached || cached.length !== sorted.length) {
                newEntries[contractId] = sorted.map((p) => (p.product ? p.product.id : p.productBundle.id));
            }
        }
        if (Object.keys(newEntries).length > 0) {
            setSortedIdsByContractId((prev) => ({ ...prev, ...newEntries }));
        }
    }, [contractPrices, pricingRequestByContractNumberId]); // eslint-disable-line react-hooks/exhaustive-deps

    const getOrderedPrices = (contractId) => {
        const ids = sortedIdsByContractId[contractId];
        if (!ids) return sortPrices(contractPrices[contractId], pricingRequestByContractNumberId[contractId]);
        return ids
            .map((id) =>
                contractPrices[contractId].find(
                    (p) => (p.product && p.product.id === id) || (p.productBundle && p.productBundle.id === id)
                )
            )
            .filter(Boolean);
    };

    const getStandardClassLabel = (standardClass) => {
        switch (standardClass) {
            case 0:
                return t('product.nonStandard');
            case 1:
                return t('product.standardClass') + ' 1';
            case 2:
                return t('product.standardClass') + ' 2';
            default:
                return '';
        }
    };

    const onAccordionChange = (evt, expanded, contractId) => {
        if (expanded && !contractPrices[contractId]) {
            getContractPrices(contractId)(dispatch);
        }
        if (expanded) setContractsExpanded({ ...contractsExpanded, [contractId]: true });
        else setContractsExpanded({ ...contractsExpanded, [contractId]: false });
    };

    const onSelectRow = (contractId, productId, productBundleId) => {
        if (!ActionAllowed(rbacactions.AdjustContractPricing, user)) return;

        if (editOpenRow.contractId) return;
        setSelectedRow({ contractId, productId, productBundleId });
    };

    const editRow = (contractId, productId, productBundleId, pricingRequest = false) => {
        if (!ActionAllowed(rbacactions.AdjustContractPricing, user)) return;

        let cp;
        if (pricingRequest) {
            cp = createContractPriceRow(contractId, productId, productBundleId);
        } else {
            cp = productId
                ? contractPrices[contractId].find((p) => p.product && p.product.id === productId)
                : contractPrices[contractId].find((p) => p.productBundle && p.productBundle.id === productBundleId);
        }
        const toEdit = new ContractPrice(cp);
        if (toEdit.price === null && toEdit.discount === null) {
            toEdit.price = productId ? toEdit.product.priceWithoutVat : toEdit.productBundle.priceWithoutVat();
        }

        setPriceInEdit(new ContractPrice(toEdit));
        setEditOpenRow({ contractId, productId, productBundleId });
    };

    const cancelEdit = () => {
        setEditOpenRow({});
        setPriceInEdit(null);
    };

    const saveRow = async (row, pricingRequestId = null) => {
        await saveContractPrice(row)(dispatch);
        if (pricingRequestId) {
            await removeContractPricePricingRequest(pricingRequestId, row.contractId)(dispatch);
        }
    };

    const isSelected = (contractId, productId, productBundleId) => {
        return (
            selectedRow.contractId === contractId &&
            selectedRow.productId === productId &&
            selectedRow.productBundleId === productBundleId
        );
    };

    const isEditOpen = (contractId, productId, productBundleId) => {
        return (
            editOpenRow.contractId === contractId &&
            editOpenRow.productId === productId &&
            editOpenRow.productBundleId === productBundleId
        );
    };

    const onChangePriceRow = (priceRow) => {
        setPriceInEdit(priceRow);
    };

    const sortPrices = (prices, pricingRequests) => {
        // when pricing request are given, the contract prices which do not have
        // price or discount set will be filtered if there is pricing request for
        // that product/bundle
        if (pricingRequests) {
            prices = filter(prices, (p) => {
                if (!p.price && !p.discount) {
                    if (
                        p.product &&
                        some(pricingRequests, (r) => {
                            return r.productId === p.product.storageId;
                        })
                    ) {
                        return false;
                    }
                    if (
                        p.productBundle &&
                        some(pricingRequests, (r) => {
                            return r.productBundleClusterId === p.productBundle.clusterId;
                        })
                    ) {
                        return false;
                    }
                }
                return true;
            });
        }

        return sortBy(prices, (o) => {
            if (o.price === null && o.discount === null) {
                if (o.product) return 'Ö' + o.product.productName;
                return 'Ö' + o.productBundle.name;
            } else {
                if (o.product) return o.product.productName;
                return o.productBundle.name;
            }
        });
    };

    const viewUsingLocations = async (contractNumberId, productNumber, bundleNumber) => {
        setLocationListDialogLoading(true);
        setLocationListDialogOpen(true);
        const locations = await getLocationsByContractNumberAndProductNumber(
            contractNumberId,
            productNumber,
            bundleNumber
        )(dispatch);
        setLocationListDialogLoading(false);
        setLocationListDialogLocations(locations);
    };

    // This is an admin-only page covering contracts across all tenants, so currency must be resolved
    // against the full tenant list (state.tenantdata.allTenants), not just the current user's assigned
    // tenants -- see doc/sweden-expansion-currency-plan.md.
    const getContractCurrency = (contractId) => {
        const contract = contracts[contractId];
        // Unresolvable contract (e.g. not yet loaded) falls back to EUR, same safe default as
        // resolveCurrencyForTenantClusterId uses for an unbound/legacy tenantCompanyClusterId.
        if (!contract) return 'EUR';
        return resolveCurrencyForTenantClusterId(tenants, contract.tenantCompanyClusterId);
    };

    const onCloseLocationListDialog = () => {
        setLocationListDialogOpen(false);
        setLocationListDialogLoading(false);
        setLocationListDialogLocations([]);
    };

    const addNewProduct = (contractId) => {
        setAddNewProdTitle(
            t('product.addProductToContract', {
                contractNumber: parameters['ContractNumber'].find((p) => p.id === contractId).value,
            })
        );
        setShowNewProdSelector(true);
        setContractIdInScope(contractId);
    };

    const getProduct = (id) => {
        //haku storageId:llä
        let product = allProducts.find((p) => p.storageId === id);
        return product;
    };

    const getBundle = (id) => {
        //haku clusterId:llä
        let bundle = bundles.find((b) => b.clusterId === id);
        return bundle;
    };

    const createContractPriceRow = (contractId, productId, bundleId) => {
        const product = getProduct(productId);
        const productBundle = getBundle(bundleId);

        const row = new ContractPrice({
            contractId: contractId,
            product: product,
            productBundle: productBundle,
            price: null,
            discount: null,
        });
        return row;
    };

    const onSelectNewProd = async (newId) => {
        setShowNewProdSelector(false);

        if (newId) {
            let product = allProducts.find((p) => p.id === newId);
            let isBundle = false;
            if (!product) {
                product = bundles.find((b) => b.id === newId);
                isBundle = true;
            }
            if (!product) throw new Error('product not found');

            if (!isBundle && contractPrices[contractIdInScope].find((p) => p.product && p.product.id === newId)) {
                toast.error(t('product.productIsAlreadyIncludedInContractPrices'), {
                    autoClose: 5000,
                    hideProgressBar: false,
                });
            } else if (
                isBundle &&
                contractPrices[contractIdInScope].find((p) => p.productBundle && p.productBundle.id === newId)
            ) {
            } else {
                const newPrice = {
                    contractId: contractIdInScope,
                    discount: 0.0,
                    price: null,
                    inUse: false,
                    product: !isBundle ? product : null,
                    productBundle: isBundle ? product : null,
                };
                await saveContractPrice(newPrice)(dispatch);
                toast.info(t('product.productWasAddedToContractPricing'), {
                    autoClose: 2000,
                    hideProgressBar: true,
                });
            }
        }
        setContractIdInScope(null);
    };

    const confirmDeleteContractPrice = async () => {
        await deleteContractPrice(itemToDelete)(dispatch);
        setItemToDelete(null);
        setDeleteConfirmTitle('');
        setConfirmDeleteOpen(false);
    };

    const onDeleteContractPrice = (contractPrice) => {
        setItemToDelete(contractPrice);
        setDeleteConfirmTitle(
            `Sopimushinnan tuotteelle "${
                contractPrice.product ? contractPrice.product.productName : contractPrice.productBundle.name
            }" ${
                contractPrice.inUse
                    ? 'Sopimushinnoiteltu tuote on käytössä kohteissa, poistaminen estää kohteiden tilaamisen'
                    : ''
            }`
        );
        setConfirmDeleteOpen(true);
    };

    const toFixedPrices = (contractId) => {
        setConfirmChangePricingSchemeText(t('product.confirmChangePricingToUseNetPrices'));
        setConfirmSchemeChangeParams({ toFixed: true, contractId });
        setConfirmChangeSchemeOpen(true);
    };

    const toPercentagePrices = (contractId) => {
        setConfirmChangePricingSchemeText(t('product.confirmChangePricingToUseDiscounts'));
        setConfirmSchemeChangeParams({ toFixed: false, contractId });
        setConfirmChangeSchemeOpen(true);
    };

    const doPricingSchemeChange = async () => {
        setConfirmChangeSchemeOpen(false);
        setSaving(true);
        let savedCount = 0;
        for (const p of sortPrices(contractPrices[confirmSchemeChangeParams.contractId])) {
            console.log('processing contract price', p);
            let newRow = new ContractPrice(p);
            if (confirmSchemeChangeParams.toFixed) {
                const rule = p.product ? pricingRuleInUse(confirmSchemeChangeParams.contractId, p.product) : null;
                if (!p.discount && !rule) continue;
                newRow.price = rule
                    ? round(p.product.priceWithoutVat * (1 - rule.discount / 100), 3)
                    : newRow.calculateDiscountPrice();
                newRow.discount = null;
            } else if (!confirmSchemeChangeParams.toFixed) {
                const rule = p.product ? pricingRuleInUse(confirmSchemeChangeParams.contractId, p.product) : null;
                if (!p.price && !rule) continue;
                newRow.discount = rule ? rule.discount : newRow.calculateDiscountPercent();
                newRow.price = null;
            } else {
                continue;
            }
            await saveContractPrice(newRow)(dispatch);
            savedCount++;
        }
        setSaving(false);
        toast.success(t('product.schemeUpdateDone', { count: savedCount }), { autoClose: 3000 });
    };

    const loadProductListXlsx = async (e, contractId) => {
        if (blobUrl) {
            e.stopPropagation();
            return;
        }
        setLoadingXlsx(true);
        const xlsx = await getProductListXlsxForContract(contractId);

        const buff = Buffer.from(xlsx, 'base64');
        const blob = new Blob([buff.buffer], {
            type: 'application/vnd.openxmlformats',
        });
        const url = URL.createObjectURL(blob);
        const contractNumber = parameters['ContractNumber'].find((c) => c.id === contractId).value;
        setBlobUrl(url);
        setDownloadFilename(`Tuotteet_${contractNumber}_${dayjs().format()}.xlsx`);

        setTimeout(() => {
            reff.current.click();
            setTimeout(() => {
                setBlobUrl('');
                setLoadingXlsx(false);
            }, 1000);
        }, 10);
    };

    const fileUpload = async (contractId, file) => {
        const fileReader = new FileReader();
        setUploading(true);
        setUploadResults(null);
        fileReader.readAsDataURL(file);
        fileReader.onload = async (e) => {
            try {
                const resp = await uploadContractPriceUpdateExcel(fileReader.result, contractId)(dispatch);
                setUploadResults(resp.result);
                setUpdateContractId(contractId);
                setCpUpdateUid(resp.uid);
                setUploading(false);
            } catch (err) {
                setUploading(false);
                setUploadResults(null);
                setUpdateContractId(null);
                setCpUpdateUid(null);
                toast.error(t('product.fileLoadFailed'), { autoClose: 5000 });
            }
        };
    };

    const parameterSelectorChange = async (name, value, contractId) => {
        const nameOfProp = name[0].toLowerCase() + name.slice(1);
        const contract = new Contract(contracts[contractId]);
        contract[nameOfProp] = parameters[name].find((item) => item.id === value);
        await updateContractData(contract)(dispatch);
    };

    const handleDeleteRule = async (contractId, ruleId) => {
        setDeletingRule(ruleId);
        const contract = new Contract(contracts[contractId]);
        contract.pricingRules = contract.pricingRules.filter((rule) => rule.id !== ruleId);
        await updateContractData(contract)(dispatch);
        setDeletingRule(null);
    };

    const handlePricingRuleChange = async (event, contractId) => {
        const ruleId = parseInt(event.target.value, 10);
        if (isNaN(ruleId) || ruleId === 0) {
            setShowPricingRuleSelect({ ...showPricingRuleSelect, [contractId]: false });
            return;
        }

        setSavingRule({ ...savingRule, [contractId]: true });

        var rule = pricingRules.find((r) => r.id === ruleId);
        if (!rule) {
            toast.error(t('product.errorRuleNotFound'), {
                autoClose: 5000,
                hideProgressBar: false,
            });
        } else {
            const contract = new Contract(contracts[contractId]);
            if (!contract.pricingRules) {
                contract.pricingRules = [];
            }
            let conflict = false;
            // check for conflict between already added rules and the selected one
            for (const r of contract.pricingRules) {
                const rMaterials = r.materials || [];
                const ruleMaterials = rule.materials || [];

                if (ruleMaterials.length === 0 || rMaterials.length === 0) {
                    if (r.standardClass === rule.standardClass && r.type === rule.type) {
                        conflict = true;
                        break;
                    }
                } else {
                    // Check if there's any overlap in materials
                    const hasOverlap = ruleMaterials.some((m) => rMaterials.includes(m));
                    if (hasOverlap && rule.type === r.type && rule.standardClass === r.standardClass) {
                        conflict = true;
                        break;
                    }
                }
            }
            if (conflict) {
                toast.error(t('product.ruleConflict'), {
                    autoClose: 5000,
                    hideProgressBar: false,
                });
            } else {
                contract.pricingRules.push(rule);
                await updateContractData(contract)(dispatch);
            }
        }

        setShowPricingRuleSelect({ ...showPricingRuleSelect, [contractId]: false });
        setSavingRule({ ...savingRule, [contractId]: false });
    };

    const pricingRuleInUse = (contractId, product) => {
        const contract = contracts[contractId];
        if (!contract) return null;
        return (
            contract.pricingRules &&
            contract.pricingRules.find((r) => {
                const materials = r.materials || [];
                const matchesMaterial = materials.some((material) => product.productName.startsWith(material));
                return (
                    matchesMaterial &&
                    product.standardClass === r.standardClass &&
                    product.type &&
                    product.type.toLowerCase() === r.type.toLowerCase()
                );
            })
        );
    };

    if (parameters == null || !pricingRequestByContractNumberId || !pricingRules)
        return <div>{t('general.loading')}</div>;
    if (!parameters['ContractNumber']) return null;

    if (updateStatus && !updateStatus.updateFinished) {
        return (
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                style={{ minHeight: '50vh' }}>
                <Grid item xs={3}>
                    {t('product.contractPricingUpdateOngoing')}
                    {dayjs(updateStatus.updateStarted).format('DD.MM.YYYY HH:mm')}
                    <br />
                    <br />
                    <CircularProgressWithLabel value={updateStatus.progressPercent} size="5rem" />
                </Grid>
            </Grid>
        );
    }

    const allParametersContractNumbers = filter(parameters['ContractNumber'], (p) => {
        //filter out "ei sopimustunnusta"
        return p.id !== 1 && p.storageId !== 0;
    });

    const sortedTenants = orderBy(tenants || [], [(tenant) => tenant.name], ['asc']);

    const parametersContractNumbers = filter(allParametersContractNumbers, (p) => {
        if (tenantFilter === null) return true;
        const contract = contracts[p.id];
        return contract && contract.tenantCompanyClusterId === tenantFilter;
    });

    const handleTenantFilterClick = (clusterId) => () => {
        setTenantFilter(tenantFilter === clusterId ? null : clusterId);
    };

    const filterAllowedPricingRulesForSelect = (contractId) => {
        if (!pricingRules) return [];

        const contract = contracts[contractId];
        if (!contract || !contract.pricingRules) return pricingRules;

        let pricingRulesAllowed = pricingRules.filter((rule) => {
            return !contract.pricingRules.some((contractRule) => contractRule.id === rule.id);
        });
        return pricingRulesAllowed;
    };

    if (!props.active) return null;

    return (
        <Grid container alignItems={'flex-end'} alignContent={'flex-end'} justifyContent={'flex-end'}>
            <Grid item xs={12}>
                <Accordion sx={styles.accordion} onChange={(evt, expanded) => {}}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} name={''}>
                        <strong>{t('product.pricingRules')}</strong>&nbsp;
                    </AccordionSummary>
                    <AccordionDetails>
                        <ContractPricesStandardPricing />
                    </AccordionDetails>
                </Accordion>
            </Grid>

            <Grid item xs={12} style={{ height: '10px' }}></Grid>
            <Grid item xs={12}>
                <Accordion sx={styles.accordion} onChange={(evt, expanded) => {}}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} name={''}>
                        <strong>{t('cargo.cargoPricing')}</strong>&nbsp;
                    </AccordionSummary>
                    <AccordionDetails>
                        <CargoPricingPanel />
                    </AccordionDetails>
                </Accordion>
            </Grid>

            <Grid item xs={12} style={{ height: '20px' }}></Grid>

            <Grid item xs={12}>
                {t('general.contractNumbers')}
            </Grid>
            <Grid item xs={12}>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 1 }}>
                    <Chip
                        label={t('general.all') || 'All'}
                        color={tenantFilter === null ? 'primary' : 'default'}
                        variant={tenantFilter === null ? 'filled' : 'outlined'}
                        onClick={handleTenantFilterClick(null)}
                    />
                    {sortedTenants.map((tenant) => (
                        <Chip
                            key={tenant.clusterId}
                            label={tenant.name}
                            color={tenantFilter === tenant.clusterId ? 'primary' : 'default'}
                            variant={tenantFilter === tenant.clusterId ? 'filled' : 'outlined'}
                            onClick={handleTenantFilterClick(tenant.clusterId)}
                        />
                    ))}
                </Stack>
            </Grid>
            <div style={{ display: 'hidden' }}>
                <a // eslint-disable-line
                    ref={reff}
                    href={blobUrl.length > 0 ? blobUrl : null}
                    download={blobUrl.length > 0 ? downloadFilename : null}></a>
            </div>
            {parametersContractNumbers.map((c) => {
                const contractIsEur = getContractCurrency(c.id) === 'EUR';
                return (
                <Grid key={c.id} item xs={12}>
                    <Accordion
                        sx={styles.accordion}
                        onChange={(evt, expanded) => onAccordionChange(evt, expanded, c.id)}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} name={'contract-prices-' + c.id}>
                            <strong>{c.value}</strong>&nbsp;
                            {pricingRequestByContractNumberId[c.id] && (
                                <span>
                                    {t('product.pricingRequests')}&nbsp;
                                    {pricingRequestByContractNumberId[c.id].length}
                                </span>
                            )}
                        </AccordionSummary>
                        <AccordionDetails>
                            {!contractIsEur && (
                                <Grid item xs={12} sx={{ mb: 2 }}>
                                    <Alert severity="info">{t('product.contractPricingNotAvailableForTenantCurrency')}</Alert>
                                </Grid>
                            )}
                            {!contractPrices[c.id] && <span>{t('general.loading')}</span>}
                            {!!contractPrices[c.id] && (
                                <Grid container>
                                    {contractPrices[c.id].length === 0 && (
                                        <Grid item xs={12}>
                                            <span>{t('product.noPricingInformation')}</span>
                                        </Grid>
                                    )}
                                    {contractPrices[c.id].length > 0 && (
                                        <Grid container spacing={1}>
                                            <Grid item>
                                                <Button
                                                    disabled={saving || !contractIsEur}
                                                    sx={styles.addbutton}
                                                    startIcon={
                                                        saving ? (
                                                            <CircularProgress size={'1rem'} />
                                                        ) : (
                                                            <SwapHorizontalCircleIcon />
                                                        )
                                                    }
                                                    variant="contained"
                                                    color="primary"
                                                    name="btn-to-fixed-prices"
                                                    onClick={() => toFixedPrices(c.id)}>
                                                    {t('product.netPrices')}
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                    disabled={saving || !contractIsEur}
                                                    sx={styles.addbutton}
                                                    startIcon={
                                                        saving ? (
                                                            <CircularProgress size={'1rem'} />
                                                        ) : (
                                                            <SwapHorizontalCircleIcon />
                                                        )
                                                    }
                                                    variant="contained"
                                                    color="primary"
                                                    name="btn-to-percentage-pricing"
                                                    onClick={() => toPercentagePrices(c.id)}>
                                                    {t('product.percentageDiscount')}
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    sx={styles.addbutton}
                                                    disabled={loadingXlsx || !contractIsEur}
                                                    name="btn-load-product-xsls"
                                                    onClick={(e) => loadProductListXlsx(e, c.id)}
                                                    startIcon={
                                                        loadingXlsx ? (
                                                            <CircularProgress color={'secondary'} size={'1rem'} />
                                                        ) : (
                                                            <CloudDownloadIcon />
                                                        )
                                                    }>
                                                    {t('location.buttons.download')}
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <CpUploadButton
                                                    disabled={uploading || !contractIsEur}
                                                    contractId={c.id}
                                                    setUploadFile={fileUpload}
                                                />
                                            </Grid>
                                        </Grid>
                                    )}
                                    {
                                        <React.Fragment key={'terms_' + c.id}>
                                            <Grid item xs={12} md={6}>
                                                <ParameterSelector
                                                    disabled={user.isAdmin !== true}
                                                    values={parameters}
                                                    category={'InvoicingTerms'}
                                                    selected={
                                                        contracts && contracts[c.id]
                                                            ? (function () {
                                                                  return contracts[c.id]
                                                                      ? contracts[c.id].invoicingTerms
                                                                      : null;
                                                              })()
                                                            : null
                                                    }
                                                    handleChange={(name, value) =>
                                                        parameterSelectorChange(name, value, c.id)
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <ParameterSelector
                                                    disabled={user.isAdmin !== true}
                                                    values={parameters}
                                                    category={'DeliveryTerms'}
                                                    selected={
                                                        contracts && contracts[c.id]
                                                            ? (function () {
                                                                  return contracts[c.id]
                                                                      ? contracts[c.id].deliveryTerms
                                                                      : null;
                                                              })()
                                                            : null
                                                    }
                                                    handleChange={(name, value) =>
                                                        parameterSelectorChange(name, value, c.id)
                                                    }
                                                />
                                            </Grid>
                                        </React.Fragment>
                                    }
                                    <Grid item xs={12}>
                                        <h4>{t('product.pricingRules')}</h4>
                                        {contracts[c.id] &&
                                            contracts[c.id].pricingRules &&
                                            contracts[c.id].pricingRules.map((rule) => {
                                                const materials = rule.materials || [];
                                                return (
                                                    <Box key={rule.id} sx={styles.ruleItem}>
                                                        <span>
                                                            <strong style={{ color: '#1976d2' }}>{rule.type}</strong>{' '}
                                                            <strong style={{ color: '#f57c00' }}>
                                                                {getStandardClassLabel(rule.standardClass)}
                                                            </strong>{' '}
                                                            <strong style={{ color: '#388e3c', fontSize: '1.1em' }}>
                                                                -{rule.discount}%
                                                            </strong>{' '}
                                                            <span style={{ fontSize: '0.9em', color: '#666' }}>
                                                                {materials.join(', ')}
                                                            </span>
                                                        </span>
                                                        <IconButton
                                                            aria-label="delete"
                                                            size="small"
                                                            onClick={() => handleDeleteRule(c.id, rule.id)}
                                                            disabled={deletingRule === rule.id || !contractIsEur}>
                                                            {deletingRule === rule.id ? (
                                                                <CircularProgress size={20} />
                                                            ) : (
                                                                <DeleteIcon />
                                                            )}
                                                        </IconButton>
                                                    </Box>
                                                );
                                            })}
                                    </Grid>
                                    <Grid item xs={12}>
                                        {contractIsEur && showPricingRuleSelect[c.id] ? (
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid item>
                                                    <FormControl
                                                        sx={styles.formControl}
                                                        disabled={savingRule[c.id]}>
                                                        <InputLabel shrink htmlFor={'pricing-rule-select-' + c.id}>
                                                            {t('product.pricingRule')}
                                                        </InputLabel>
                                                        <NativeSelect
                                                            value={0}
                                                            onChange={(e) => handlePricingRuleChange(e, c.id)}
                                                            inputProps={{
                                                                name: 'pricing-rule',
                                                                id: 'pricing-rule-select-' + c.id,
                                                            }}>
                                                            <option value={0}>-Valitse-</option>
                                                            {filterAllowedPricingRulesForSelect(c.id, pricingRules).map(
                                                                (rule) => {
                                                                    const materials = rule.materials || [];
                                                                    return (
                                                                        <option key={rule.id} value={rule.id}>
                                                                            {rule.type} {materials.join(', ')} std
                                                                            {rule.standardClass} {rule.discount}%
                                                                        </option>
                                                                    );
                                                                }
                                                            )}
                                                        </NativeSelect>
                                                    </FormControl>
                                                </Grid>
                                                {savingRule[c.id] && (
                                                    <Grid item>
                                                        <CircularProgress size={24} />
                                                    </Grid>
                                                )}
                                            </Grid>
                                        ) : (
                                            <Button
                                                sx={styles.addbutton}
                                                startIcon={<AddIcon />}
                                                variant="contained"
                                                color="primary"
                                                disabled={!contractIsEur}
                                                onClick={() =>
                                                    setShowPricingRuleSelect({
                                                        ...showPricingRuleSelect,
                                                        [c.id]: true,
                                                    })
                                                }>
                                                {t('buttons.add')}
                                            </Button>
                                        )}
                                    </Grid>

                                    {pricingRequestByContractNumberId[c.id] && (
                                        <React.Fragment key={'pricingrequests_' + c.id}>
                                            <h4>{t('product.pricingRequests')}</h4>
                                            <br />
                                            {pricingRequestByContractNumberId[c.id].map((cp) => (
                                                <ContractPricesProduct
                                                    priceRow={
                                                        isEditOpen(
                                                            c.id,
                                                            cp.productId ? cp.productId : null,
                                                            cp.productBundleClusterId ? cp.productBundleClusterId : null
                                                        )
                                                            ? priceInEdit
                                                            : createContractPriceRow(
                                                                  c.id,
                                                                  cp.productId,
                                                                  cp.productBundleClusterId
                                                              )
                                                    }
                                                    key={cp.productId ? cp.productId : cp.productBundleClusterId}
                                                    edit={isEditOpen(
                                                        c.id,
                                                        cp.productId ? cp.productId : null,
                                                        cp.productBundleClusterId ? cp.productBundleClusterId : null
                                                    )}
                                                    highlight={isSelected(
                                                        c.id,
                                                        cp.productId ? cp.productId : null,
                                                        cp.productBundleClusterId ? cp.productBundleClusterId : null
                                                    )}
                                                    selectRow={() =>
                                                        onSelectRow(
                                                            c.id,
                                                            cp.productId ? cp.productId : null,
                                                            cp.productBundleClusterId ? cp.productBundleClusterId : null
                                                        )
                                                    }
                                                    editRow={() =>
                                                        editRow(
                                                            c.id,
                                                            cp.productId ? cp.productId : null,
                                                            cp.productBundleClusterId
                                                                ? cp.productBundleClusterId
                                                                : null,
                                                            true
                                                        )
                                                    }
                                                    save={async (row) => await saveRow(row, cp.id)}
                                                    cancel={cancelEdit}
                                                    onChange={onChangePriceRow}
                                                    delete={onDeleteContractPrice}
                                                    pricingRequest={true}
                                                    viewUsingLocations={viewUsingLocations}
                                                    currency={getContractCurrency(c.id)}
                                                    disabled={!contractIsEur}
                                                />
                                            ))}
                                        </React.Fragment>
                                    )}
                                    {contractPrices[c.id].length !== 0 && (
                                        <Grid item xs={12}>
                                            <strong>{t('product.contractPrices')}</strong>
                                        </Grid>
                                    )}
                                    {getOrderedPrices(c.id).map(
                                        (p) => (
                                            <React.Fragment key={p.product ? p.product.id : p.productBundle.id}>
                                                {p.product ? (
                                                    <ContractPricesProduct
                                                        priceRow={
                                                            isEditOpen(c.id, p.product.id, null) ? priceInEdit : p
                                                        }
                                                        key={p.product.id}
                                                        edit={isEditOpen(c.id, p.product.id, null)}
                                                        highlight={isSelected(c.id, p.product.id, null)}
                                                        selectRow={() => onSelectRow(c.id, p.product.id, null)}
                                                        editRow={() => editRow(c.id, p.product.id, null)}
                                                        save={async (row) => await saveRow(row)}
                                                        cancel={cancelEdit}
                                                        onChange={onChangePriceRow}
                                                        delete={onDeleteContractPrice}
                                                        pricingRule={pricingRuleInUse(c.id, p.product)}
                                                        viewUsingLocations={viewUsingLocations}
                                                        currency={getContractCurrency(c.id)}
                                                        disabled={!contractIsEur}
                                                    />
                                                ) : (
                                                    <ContractPricesProduct
                                                        priceRow={
                                                            isEditOpen(c.id, null, p.productBundle.id) ? priceInEdit : p
                                                        }
                                                        key={p.productBundle.id}
                                                        edit={isEditOpen(c.id, null, p.productBundle.id)}
                                                        highlight={isSelected(c.id, null, p.productBundle.id)}
                                                        selectRow={() => onSelectRow(c.id, null, p.productBundle.id)}
                                                        editRow={() => editRow(c.id, null, p.productBundle.id)}
                                                        save={async (row) => await saveRow(row)}
                                                        cancel={cancelEdit}
                                                        onChange={onChangePriceRow}
                                                        delete={onDeleteContractPrice}
                                                        pricingRule={null}
                                                        viewUsingLocations={viewUsingLocations}
                                                        currency={getContractCurrency(c.id)}
                                                        disabled={!contractIsEur}
                                                    />
                                                )}
                                            </React.Fragment>
                                        )
                                    )}
                                    <Grid item xs={12}>
                                        <Button
                                            disabled={saving || !contractIsEur}
                                            sx={styles.addbutton}
                                            startIcon={<AddIcon />}
                                            variant="contained"
                                            color="primary"
                                            name="btn-add-new-product"
                                            onClick={() => addNewProduct(c.id)}>
                                            {t('general.product')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            )}
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                );
            })}
            <FilterProductSelectDialog
                allowNewProd={false}
                title={addNewProdTitle}
                show={showNewProdSelector}
                selected={onSelectNewProd}
                showBundles={true}
            />
            <DeleteConfirmDialog
                open={confirmDeleteOpen}
                itemToDelete={deleteConfirmTitle}
                cancel={() => {
                    setConfirmDeleteOpen(false);
                    setItemToDelete(null);
                    setDeleteConfirmTitle('');
                }}
                confirmDelete={confirmDeleteContractPrice}
            />
            <ConfirmationDialog
                open={confirmChangeSchemeOpen}
                confirm={doPricingSchemeChange}
                cancel={() => setConfirmChangeSchemeOpen(false)}
                confirmText={t('product.change')}>
                {confirmChangePricingSchemeText}
            </ConfirmationDialog>
            <ConfirmationDialog
                open={!!uploadResults}
                confirm={() => {
                    setUploadResults(null);
                    doContractPriceUpdates(cpUpdateUid, updateContractId)(dispatch);
                }}
                cancel={() => {
                    setUploadResults(null);
                    setUpdateContractId(null);
                    setCpUpdateUid(null);
                    setUploading(false);
                }}
                confirmText={t('buttons.update')}>
                {uploadResults && (
                    <Grid item container>
                        <Grid item xs={12}>
                            <strong>{t('product.fileLoaded')}</strong>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {t('parameterCategories.ContractNumber')}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {uploadResults.contractNumber.value}
                        </Grid>

                        <Grid item xs={12} md={6}>
                            {t('product.rowsAltogether')}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {uploadResults.totalLinesRead}
                        </Grid>

                        <Grid item xs={12} md={6}>
                            {t('product.pricingChanges')}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {uploadResults.changedPricesCount}
                        </Grid>

                        <Grid item xs={12} md={6}>
                            {t('product.newContractPricesToCreate')}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {uploadResults.addedPricesCount}
                        </Grid>

                        <Grid item xs={12} md={6}>
                            {t('product.productNotFoundInCatalog')}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {uploadResults.notFoundProducts.length}
                        </Grid>
                    </Grid>
                )}
            </ConfirmationDialog>
            <LocationListDialog
                open={locationListDialogOpen}
                onClose={onCloseLocationListDialog}
                locations={locationListDialogLocations}
                loading={locationListDialogLoading}
            />
        </Grid>
    );
}
